var _path, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E83B7",
    d: "m440 360 62-213H119.373L94.734 40H10v32h59.266L136 361.818V440h304v-32H168v-48z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEFF1",
    cx: 168,
    cy: 455,
    r: 47
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#D3D3D3",
    cx: 168,
    cy: 455,
    r: 20
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEFF1",
    cx: 366.286,
    cy: 455,
    r: 47
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#D3D3D3",
    cx: 366.286,
    cy: 455,
    r: 20
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.21cdc9615d8418c2d5fc9aacf3468590.svg";
export { ForwardRef as ReactComponent };